<template>
  <div>
    <button
      class="c-chat__inputButton c-chat__emojiButton"
      :disabled="disabled"
      @click="toggleEmojiPicker">
      <SvgIcon
        small
        type="chat_emoji" />
    </button>
    <!-- To remove Emoji Mart text we set title to empty string,
     and emoji=smile to set the default emoji when open the emoji picker -->
    <Picker
      v-if="showEmojiPicker && !disabled"
      ref="emojiPicker"
      class="emoji-picker"
      emoji="smile"
      title=""
      :i18n="emojiPickerTranslations"
      :custom="customEmojis"
      :style="pickerStyle"
      @select="insertEmoji" />
  </div>
</template>

<script setup>
import {
  computed,
  onBeforeUnmount,
  onMounted,
  ref,
  defineAsyncComponent,
} from 'vue'

import api from '@/logic/api'
import { getEmojiMartCustom } from '@/logic/emoji/customEmojis'

const Picker = defineAsyncComponent(async () => (await import('emoji-mart-vue')).Picker)

const props = defineProps({
  editorRef: {
    type: Object,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const emojiPickerTranslations = computed(() => ({
  search: api.i18n.t('emojiPicker.search'),
  notfound: api.i18n.t('emojiPicker.notfound'),
  categories: {
    search: api.i18n.t('emojiPicker.categories.search'),
    recent: api.i18n.t('emojiPicker.categories.recent'),
    people: api.i18n.t('emojiPicker.categories.people'),
    nature: api.i18n.t('emojiPicker.categories.nature'),
    foods: api.i18n.t('emojiPicker.categories.foods'),
    activity: api.i18n.t('emojiPicker.categories.activity'),
    places: api.i18n.t('emojiPicker.categories.places'),
    objects: api.i18n.t('emojiPicker.categories.objects'),
    symbols: api.i18n.t('emojiPicker.categories.symbols'),
    flags: api.i18n.t('emojiPicker.categories.flags'),
    custom: api.i18n.t('emojiPicker.categories.custom'),
  },
}))

const showEmojiPicker = ref(false)
const customEmojis = getEmojiMartCustom()

const pickerStyle = ref({
  position: 'absolute', bottom: '60px', right: '20px', zIndex: 1000,
})

const toggleEmojiPicker = () => {
  showEmojiPicker.value = !showEmojiPicker.value
}
const handleClickOutside = (event) => {
  const emojiPicker = document.querySelector('.emoji-picker')

  if (!emojiPicker?.contains(event.target) && !event.target.classList.contains('c-chat__emojiButton')) {
    showEmojiPicker.value = false
  }
}
const handleKeyDown = (event) => {
  if (event.key === 'Escape') {
    showEmojiPicker.value = false
  }
}

const insertEmoji = (emoji) => {
  if (emoji.native) {
    props.editorRef.editor.chain()
      .focus()
      .insertContent(emoji.native)
      .run()
  }
  if (emoji.imageUrl) {
    props.editorRef.editor.chain()
      .focus()
      .setImage({ src: emoji.imageUrl, alt: `:${emoji.id}:` })
      .run()
  }
  showEmojiPicker.value = false
}

onMounted(async () => {
  document.addEventListener('click', handleClickOutside)
  document.addEventListener('keydown', handleKeyDown)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside)
  document.removeEventListener('keydown', handleKeyDown)
})
</script>
